import { render, staticRenderFns } from "./SiteAlerts.vue?vue&type=template&id=c1c85ee8&"
import script from "./SiteAlerts.vue?vue&type=script&lang=js&"
export * from "./SiteAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports